import { type ReactNode } from "react";

export function SectionHeader({
  eyebrow,
  title,
  action,
}: {
  eyebrow?: string;
  title: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex items-end justify-between gap-4 border-b border-foreground pb-3">
      <div>
        {eyebrow && (
          <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-verified">
            {eyebrow}
          </div>
        )}
        <h2 className="mt-1 font-serif text-2xl md:text-3xl font-semibold tracking-tight text-foreground">
          {title}
        </h2>
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
